module.exports = __webpack_public_path__ + "static/media/custom_color_pocket.54df1e28.svg";